import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37c2af5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "svg-icon svg-icon-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请输入0~10中的数字，默认为1，其中0~1是降权，1~10是加权", -1))
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关闭")

import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/Datatable2.vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'recommend/season';
const tableHeader = ref([
  {
    name: "ID",
    key: "id",
    width: 50
  },
  {
    name: "名称",
    key: "name",
  },
  {
    name: "类目",
    key: "category_name",
  },
  {
    name: "区域",
    key: "area",
  },
  {
    name: "维护人",
    key: "user"
  },
  {
    name: "创建时间",
    key: "create_time",
  },
  {
    name: "更新时间",
    key: "update_time",
  },
]);
const filters = reactive({
  search: '',
  page_id: 2
})
const formData = reactive({
  id: 0,
  name: '',
  page_id: 0,
  category_id: [],
  area: '',
  value: [] as any[],
});

const validateNameExist = (rule, value, callback) => {
  let name = '';
  (dataT as any).value.tableData.some((item)=>{
    name = item.name;
    return item.id == formData.id;
  });
  if (value === '') {
    callback(new Error('请输入名称！'))
  } else if (formData.id == 0 || (formData.id > 0 && value != name)) {
    ApiService.get(apiUrl + '/exist', {name: value}).then(({data}) => {
      if (data == true) callback(new Error('该名称已存在！'))
      else callback()
    })
  } else {
    callback()
  }
}
const rules = {
  name: [
    { required: true, message: '请输入名称！', trigger: 'blur' },
    { validator: validateNameExist, trigger: 'blur' },
  ],
  area: [
    { required: true, message: '请选择区域', trigger: 'change' }
  ],
  category_id: [
      { required: true, type: 'array', message: '请选择类目', trigger: 'change' }
  ],
};

const config = reactive({
  config: {} as any,  //模块配置
  area: [] as any[],  //站点区域配置
  category: [] as any[],  //站点栏目类目配置
  page: [] as any[],  //栏位
  dimension: [] as any[],  //站点维度配置
  attrs: {} as any,  //站点维度属性配置
  sorting_key: [] as any[],  //站点排序
})
const dialogResult = ref(false);  //结果弹框
const result = ref({});  //当前结果值

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("recommend.season", ["recommend.name"]);

  if ((dataT as any) != undefined) (dataT as any).value.btnLoading = true;
  ApiService.get(apiUrl + '/config').then(({data}) => {
    if (data.page.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      config.config = data.config;
      config.page = [...data.page];
      let page;
      config.page.forEach((p) => {
        if(p.id == 2 && p.is_active == true) page = p;
        else p.is_active=false;
      });
      if (!page) {
        ElMessage.error('默认栏位尚未开启，请与管理员联系！');
      } else {
        config.sorting_key = [...data.sorting_key];
        if ((dataT as any) != undefined) (dataT as any).value.btnLoading = false;
        changePage(page.id);
      }
    }
  });
});

const add = function() {
  let page = config.page.find((p) => {
    return p.id == 2 && p.is_active == true;
  });
  if (page){
    formData.page_id = page.id;
    formData.area = config.area[0].name;
  }
  formData.value = [];
  for (let i = 1; i <= 12; i++) {
    formData.value.push({
      m: i,
      sp: 1,
      su: 1,
      a: 1,
      w: 1,
      n: 1,
    })
  }
};

const edit = function(item) {
  formData.category_id = item.category_ids
  formData.value = item.value;
};

// 栏位改变
const changePage = function(val) {
  let _categoryTree = (category) => {
    let tree: Array<any> = []
    for(let c of category) {
      let t = {
        label: c.category_name,
        value: c.category_id,
      }
      if (c.children) {
        t['children'] = _categoryTree(c.children)
      }
      tree.push(t)
    }
    return tree
  }
  ApiService.get(apiUrl + '/category', {page: val}).then(({data}) => {
    if (data.area.length < 1) {
      if ((dataT as any) != undefined) (dataT as any).value.btnLoading = true;
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      if ((dataT as any) != undefined) (dataT as any).value.btnLoading = false;
      formData.area = data.area[0].name;
      config.area = [...data.area];
      config.category = _categoryTree(data.category);
    }
  })
};

// 查看结果弹层
const openResult = (r) => {
  dialogResult.value = true;
  result.value = r;
};

const submit = function () {
  if(formData.page_id == 0){

    return false;
  } else return true;
}

const nl2br = function (str) {
  return str.replace(/[\r\n]/g,'<br>');
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Datatable, {
      ref_key: "dataT",
      ref: dataT,
      apiUrl: apiUrl,
      "table-header": tableHeader.value,
      "enable-items-per-page-dropdown": true,
      data: _unref(formData),
      rules: rules,
      filters: _unref(filters),
      title: "季节配置",
      addAction: add,
      editAction: edit,
      submitAction: submit,
      delete: false
    }, {
      "search-back": _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_radio_group, {
          modelValue: _unref(filters).page_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).page_id) = $event)),
          size: "small",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (dataT.value.setCurrent(1)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).page, (v) => {
              return (_openBlock(), _createBlock(_component_el_radio_button, {
                key: v.id,
                label: v.id,
                disabled: !v.is_active
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v.name), 1)
                ]),
                _: 2
              }, 1032, ["label", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      "cell-category_name": _withCtx(({ row: r }) => [
        _createElementVNode("div", {
          innerHTML: nl2br(r.category_names.join('\n'))
        }, null, 8, _hoisted_2)
      ]),
      "cell-user": _withCtx(({ row: r }) => [
        _createTextVNode(_toDisplayString(r.user.username), 1)
      ]),
      "actions-front": _withCtx(({ row: r }) => [
        _createElementVNode("div", {
          title: "查看结果",
          onClick: ($event: any) => (openResult(r)),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
          ])
        ], 8, _hoisted_3)
      ]),
      form: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).name) = $event)),
              placeholder: "请填写季节配置名称",
              size: "small",
              style: {"width":"400px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_unref(config).category.length > 0)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "商品类目",
              prop: "category_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: _unref(formData).category_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).category_id) = $event)),
                  options: _unref(config).category,
                  props: { checkStrictly: true, emitPath: false, multiple: true },
                  placeholder: "请选择类目",
                  size: "small",
                  "collapse-tags": "",
                  style: {"width":"400px"}
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "区域",
          prop: "area"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).area,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).area) = $event)),
              size: "small"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).area, (v) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: v.name,
                    label: v.name
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "季节配置",
          prop: "value"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _unref(formData).value,
              stripe: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "月份",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.m + "月"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "春",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.sp,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.sp) = $event),
                      size: "small",
                      min: 0,
                      precision: 1,
                      step: 0.1,
                      max: 10,
                      controls: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "夏",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.su,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.su) = $event),
                      size: "small",
                      min: 0,
                      precision: 1,
                      step: 0.1,
                      max: 10,
                      controls: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "秋",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.a,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.a) = $event),
                      size: "small",
                      min: 0,
                      precision: 1,
                      step: 0.1,
                      max: 10,
                      controls: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "冬",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.w,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.w) = $event),
                      size: "small",
                      min: 0,
                      precision: 1,
                      step: 0.1,
                      max: 10,
                      controls: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "无",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.n,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.n) = $event),
                      size: "small",
                      min: 0,
                      precision: 1,
                      step: 0.1,
                      max: 10,
                      controls: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["table-header", "data", "filters"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogResult.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogResult).value = $event)),
      title: "配置结果",
      width: "50%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogResult.value = false)),
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { style: {"margin-top":"-40px","margin-bottom":"-50px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: result.value.value,
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "月份",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.m + "月"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "sp",
                      label: "春",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "su",
                      label: "夏",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "a",
                      label: "秋",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "w",
                      label: "冬",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "n",
                      label: "无",
                      align: "center"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})